import { Inventory2Outlined } from '@mui/icons-material';
import { Divider } from '@mui/material';
import { AssetsIcon } from '@/components/AssetsIcon';
import { useTenants } from '@/services/tenants/useTenants';
import { AssetFileTypesSection } from './AssetFileTypesSection';
import { DashboardTile } from './DashboardTile';
import { TileEmptyState } from './TileEmptyState';
import { UsageSection } from './UsageSection';
import { useUploadAssetsAction } from './useUploadAssetsAction';

export const AssetsTile = ({
  assetsUsed,
  isLoading,
  pollWhileIndexing,
}: {
  assetsUsed: number;
  isLoading: boolean;
  pollWhileIndexing?: boolean;
}) => {
  const { getPath } = useTenants();
  const uploadAssetsAction = useUploadAssetsAction();
  const isEmpty = !isLoading && assetsUsed === 0;

  return (
    <DashboardTile id='assets' title='Assets' icon={<AssetsIcon />} to={getPath('assets')}>
      {isEmpty && (
        <TileEmptyState
          testId='no-assets'
          graphic={<Inventory2Outlined />}
          title='No assets yet'
          description='Upload a part to see counts by file type here.'
          action={uploadAssetsAction}
        />
      )}
      {!isEmpty && <UsageSection assetsUsed={assetsUsed} isLoading={isLoading} />}
      {/* The rule separates the usage figure from the type breakdown, so it goes when
          the breakdown does, rather than trailing off under an empty tile. */}
      {assetsUsed > 0 && (
        <>
          <Divider />
          <AssetFileTypesSection assetsTotal={assetsUsed} pollWhileIndexing={pollWhileIndexing} />
        </>
      )}
    </DashboardTile>
  );
};
